export async function updateBlog(blog) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/blogs/${blog.id}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(blog),
      }
    );
    const updatedBlog = await response.json();

    return updatedBlog;
  } catch (error) {
    console.error(error);
  }
}
